import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import { useParams, useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchItCategory, removeItCategoryApplicationCategory } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";
import ConfirmDialog from "../../components/common/ConfirmDialog";

export default function ItCategoryApplicationCategoryListPage() {
  const { businessDomainId, categoryId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [rows, setRows] = useState([]);
  const [categoryName, setCategoryName] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [targetRow, setTargetRow] = useState(null);

  const basePath = `/strategy/${businessDomainId}/it-categories/${categoryId}`;

  const loadData = useCallback(async () => {
    try {
      const d = await fetchItCategory(categoryId);
      setCategoryName(d.itCategoryName || "");
      setRows((d.applicationCategories || []).map((ac, i) => ({ id: i, ...ac })));
    } catch (e) { notify.apiError(e); }
  }, [categoryId]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleDeleteClick = (row) => { setTargetRow(row); setConfirmOpen(true); };

  const handleDelete = async () => {
    try {
      await removeItCategoryApplicationCategory(categoryId, targetRow.applicationCategoryId);
      notify.success(t("message.delete.success"));
      loadData();
    } catch (e) { notify.apiError(e); }
    setConfirmOpen(false);
  };

  const columns = [
    { field: "applicationCategoryName", headerName: t("itCategory.applicationCategoryName"), flex: 1, minWidth: 200 },
    {
      field: "actions",
      headerName: "",
      width: 60,
      sortable: false,
      renderCell: (params) => (
        <IconButton size="small" color="error"
          onClick={(e) => { e.stopPropagation(); handleDeleteClick(params.row); }}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      ),
    },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{categoryName}：{t("itCategory.applicationCategories")}</Typography>
        <Button variant="contained" startIcon={<AddIcon />}
          onClick={() => navigate(`${basePath}/application-categories/add`)}>
          {t("common.add")}
        </Button>
      </Box>

      <Box sx={{ height: 400 }}>
        <DataGrid rows={rows} columns={columns} disableRowSelectionOnClick hideFooterSelectedRowCount />
      </Box>

      <Box sx={{ mt: 2 }}>
        <Button variant="outlined" onClick={() => navigate(basePath)}>{t("common.back")}</Button>
      </Box>

      <ConfirmDialog open={confirmOpen} onConfirm={handleDelete} onCancel={() => setConfirmOpen(false)} />
    </Box>
  );
}
